export default __webpack_public_path__ + "static/media/happy1.a3eb4ca1.jpg";